import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  bulletins: [],
  error: null,
};

export default function bulletinReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_BULLETIN_REQUEST:
    case actionTypes.UPDATE_BULLETIN_REQUEST:
    case actionTypes.DELETE_BULLETIN_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.SAVE_BULLETIN_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletins: [...state.bulletins, action.payload],
      };

    case actionTypes.UPDATE_BULLETIN_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletins: state.bulletins.map((b) =>
          b.bulletinObjId === action.payload.bulletinObjId ? action.payload : b
        ),
      };

    case actionTypes.DELETE_BULLETIN_SUCCESS:
      return {
        ...state,
        loading: false,
        bulletins: state.bulletins.filter(
          (b) => b.bulletinObjId !== action.payload.bulletinObjId
        ),
      };

    case actionTypes.SAVE_BULLETIN_FAILURE:
    case actionTypes.UPDATE_BULLETIN_FAILURE:
    case actionTypes.DELETE_BULLETIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
